const root = document.body.style;

export function setTemaGeral(themes, custom, isDark) {
    if (!!isDark && !custom)
        themes = INITIAL_DARK;
    else if (!!custom)
        themes = custom;
    else if (themes == "THEME_DEFAULT") {
        document.body.className = "";
        root.setProperty('--spinner-color', "#1890ff");
        root.setProperty('--font-color-menu', "#fff");
        root.setProperty('--font-color-all', "#555");
        root.setProperty('--font-color-components', "#fff");
        root.setProperty('--components-background', "#1890ff");
        root.setProperty('--components-box-shadow', "rgba(24, 144, 255, 0.2)");
        root.setProperty('--background-color-menu', "#1976d2");
        root.setProperty('--background-color', "#fff");
        return;
    }

    document.body.className = `layout-custom ${isDark ? "dark-padrao" : ""}`;

    root.setProperty('--background-color-menu', themes.backgroundMenu);
    root.setProperty('--font-color-menu', themes.fontColorMenu);
    root.setProperty('--components-background', themes.compBackground);
    root.setProperty('--components-hover', themes.compHover);
    root.setProperty('--components-box-shadow', themes.compBoxShadow);
    root.setProperty('--font-color-components', themes.fontColorComp);
    root.setProperty('--font-color-all', themes.fontColorAll);
    root.setProperty('--background-color', themes.background);
    root.setProperty('--spinner-color', themes.spinnerColor);
}

const INITIAL_DARK = {
    backgroundMenu: "#252525",
    fontColorMenu: "#fff",
    fontColorMenuHover: "rgba(255, 255, 255, 0.65)",
    compBackground: "#727272",
    compHover: "#8a8a8a",
    compBoxShadow: "rgba(67, 67, 67, 0.65)",
    fontColorComp: "#fff",
    fontColorAll: "#fff",
    background: "#1e1e1e",
    spinnerColor: "#ddd",
};